import { createSafeUrl } from "@/lib/utils";
import { Link } from "@heroui/link";
import React, { forwardRef } from "react";

type ExternalLinkProps = {
  href: string;
  children: React.ReactNode;
  className?: string;
  queryParams?: Record<string, string>;
  underline?: "none" | "hover" | "always";
  target?: string;
  rel?: string;
  [key: string]: any;
};

/**
 * Component for external links that safely encodes URL parameters to prevent "URI malformed" errors
 */
export const ExternalLink = forwardRef<HTMLAnchorElement, ExternalLinkProps>(
  (
    {
      href,
      children,
      className = "",
      queryParams,
      underline = "hover",
      target = "_blank",
      rel = "noopener noreferrer",
      ...props
    },
    ref,
  ) => {
    const safeHref = queryParams
      ? queryParams.href
        ? href
        : createSafeUrl(href, queryParams)
      : href;

    return (
      <Link
        href={safeHref}
        className={className}
        target={target}
        rel={rel}
        underline={underline}
        ref={ref}
        {...props}
      >
        {children}
      </Link>
    );
  },
);
